import { IApiAction } from '../../models/ActionModels';
import { ActionSubTypes } from '../../actions/ActionSubTypes';
import { LoginManager } from '../../api/core/LoginManager';
import rKullanici from '../../api/models/rKullanici';

export const AuthMiddleware = (store: any) => (next: any) => (action: IApiAction) => {
  if ('isInterfaceApiAction' in action) {
    if (action.subtype === ActionSubTypes.API_OTURUMAC) {
      if (action.payload.hasError && action.payload?.error) {
        LoginManager.LoginFailed({
          detail: {
            type: action.type,
            subtype: action.subtype,
            error: action.payload.error,
          },
        });
      } else {
        if ((action.payload.data as rKullanici).SifreDegistirilmeli === true) {
          LoginManager.PasswordChangeNeeded();
        } else {
          LoginManager.PasswordChangeNotNeeded();
        }
        LoginManager.LoggedIn({
          detail: {
            type: action.type,
            subtype: action.subtype,
          },
        });
      }
    } else if (
      action.payload.hasError &&
      (action.payload.error?.ErrorCode === 'E3' || action.payload.error?.ErrorCode === 'E7')
    ) {
      LoginManager.Expired({
        detail: {
          type: action.type,
          subtype: action.subtype,
          error: action.payload.error,
        },
      });
    }
  }

  next(action);
};
